var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#-icons-/-arrow-right-small-2-gradient-1",
    transform: "translate(-19.000000, -18.000000)",
    fill: "#17B0B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,23.4530818 L18.5386608,27.7459751 C18.1866709,28.084675 17.6159824,28.084675 17.2639925,27.7459751 C16.9120025,27.4072751 16.9120025,26.8581341 17.2639925,26.5194341 L23,21 L28.7360075,26.5194341 C29.0879975,26.8581341 29.0879975,27.4072751 28.7360075,27.7459751 C28.3840176,28.084675 27.8133291,28.084675 27.4613392,27.7459751 L23,23.4530818 Z",
    id: "Combined-Shape",
    transform: "translate(23.000000, 24.500000) rotate(90.000000) translate(-23.000000, -24.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.4218a81d9b405d12e6d7b28a6177d431.svg";
export { ForwardRef as ReactComponent };